import React, { useEffect, useState } from 'react'
import { Row, Radio, Col, Card, Tag, Button, Table, Input, Divider, Space, Dropdown, Spin, Modal, Form, Select, DatePicker, Tabs } from "antd";
import backArrow from '../../../assets/images/arrow-left-back.svg';
import arrow from '../../../assets/images/arrow.svg';
import calenderIcon from '../../../assets/images/calendar-icon.svg';
import moxeyIcon from '../../../assets/images/Moxey 1.svg';
import bankIcon from '../../../assets/images/fluent-emoji_bank.svg';
import cashIcon from '../../../assets/images/Group.svg';
import doubleCheckIcon from '../../../assets/images/check-double-fill.svg';
import { useNavigate ,useLocation } from 'react-router-dom';
import './tnx-order-details.scss';


const TnxOrderDetails = () => {
    const navigate = useNavigate();
    const location = useLocation();
  
    // Destructure the state object to access orderData and orderIndex
    // const {orderData ,orderIndex} = location.state || {};
  
    const [orderDetails, setOrderDetails] = useState({
      
    });

    const activeTab = location.state?.activeTab || "transaction";
    const transactionTab = location.state?.transactionTab || "Order";
    const currency = location.state?.currency
    const orderIndex = location.state?.orderIndex;
    console.log(orderIndex,"oi")
    const orderData = location.state?.orderData || {};
    useEffect(() => {
        setOrderDetails(orderData);
        console.log(orderData, "data");
      }, [orderData]);
    
    const getIcon = (paymentMode) => {
        const iconMap = {
            Wallet: moxeyIcon,
            Bank: bankIcon,
            Cash: cashIcon,
            null: cashIcon,
            "Bank Transfer":bankIcon
        };
        return iconMap[paymentMode] || null;
    };
    function formatDate(dateString) {
        const date = new Date(dateString);
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
      }
      
    return (

        <div className='card-container'>
            <div className='tnx-id'>
                <img src={backArrow} alt='backIcon'   style={{ cursor: "pointer" }}
                      onClick={() => navigate("/earnings", { state: { activeTab  , transactionTab  } })} />
                <span style={{ marginLeft: "10px", fontWeight: 700, fontSize: "24px" }}>
                    {orderDetails?.orderNumber || "#ORD000000000"}
                </span>
            </div>

            <div className='amount-container'>
                <div className='amount-value'>
                    <span>
                        Total Order Amt: <span className='amt-color'>{currency} {orderDetails?.paymentSummary?.totalOrderAmount || "0"}</span>
                    </span>
                    <span>
                        Total Amt Received: <span className='amt-color-received'> {currency} {orderDetails?.paymentSummary?.totalPaymentReceived || "0"}</span>
                    </span>
                    <span>Total Amt Pending:<span className='amt-pen'> {currency} {orderDetails?.paymentSummary?.totalPaymentPending || "0"}</span></span>
                </div>
                <div className='amount-status'>
                    <Tag bordered={false} className='tag-color'>
                        {orderDetails?.paymentSummary?.paymentStatus || "Status Pending"}
                    </Tag>
                </div>
            </div>

            <hr style={{ border: "1px dashed #858C9480", opacity: "50%" }} />

            <div className='date-container'>
                <div className='moveDate'>
                    <span>
                        <img src={calenderIcon} alt='date' />
                    </span>
                    <span>Move Date: {formatDate(orderDetails?.moveDate) || "N/A"}</span>
                </div>
                <span className='move-type'>{orderDetails?.moveType || "N/A"}</span>
            </div>

            <div className='movement-container'>
                <div className='moveDetails'>
                    <span>From</span>
                    <strong>{orderDetails?.fromCity || "City"}</strong>
                    <span>{orderDetails?.fromCountry || "Country"}</span>
                </div>
                <div className='arrow'>
                    <img src={arrow} alt='' />
                </div>
                <div  className='moveDetails position'>
                    <span>To</span>
                    <strong>{orderDetails?.toCity || "City"}</strong>
                    <span>{orderDetails?.toCountry || "Country"}</span>
                </div>
            </div>


            <div className='transaction-details-card'>
                {orderDetails?.payments?.map((txn, index) => (
                    <div key={index} className='tnx-mode'>
                        <div className='tnx-img'>
                            <span>
                                <img src={getIcon(txn?.payment_mode)} alt='icon' />
                            </span>
                            <div className='payment-id'>
                                <span>{txn?.voucherId || "Transaction ID"}</span>
                                <span className='text-pay'>Payment received in {txn?.payment_mode}</span>
                            </div>
                        </div>
                        <div className='payment-details'>
                            <span>
                            {txn?.currency} {txn?.amount || "0"}{" "}
                                {<img src={doubleCheckIcon} alt='checkedIcon' />}
                            </span>
                            <span className='text-pay'>{formatDate(txn?.paidAt) || "N/A"}</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>

    );
};

export default TnxOrderDetails;